import { render, staticRenderFns } from "./OrderNavbar.vue?vue&type=template&id=0b931fa9&scoped=true"
import script from "./OrderNavbar.vue?vue&type=script&lang=ts"
export * from "./OrderNavbar.vue?vue&type=script&lang=ts"
import style0 from "./OrderNavbar.vue?vue&type=style&index=0&id=0b931fa9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b931fa9",
  null
  
)

export default component.exports